import { createNode } from '@glueapp/graph-types';

export const PI = createNode({
    id: 'PI',
    name: 'PI',
    description: "Ratio of the a circle's circumference to its diameter; approximately 3.14159.",
    aiDescription:
        'Outputs the mathematical constant PI (approximately 3.14159). Has no input ports; the "PI" output port provides the value.',
    category: 'Math',
    color: '#5daa5b',
    integration: undefined,
    inPorts: {},
    outPorts: {
        PI: {
            kind: 'number',
        },
    },
    execute: function () {
        return { output: { PI: Math.PI } };
    },
});
